<template>
  <Select
    v-model="baseInfo.placeId"
    placeholder="请选择上课地点"
    class="form-line-content"
    filterable
    allow-create
    clearable
    label-in-value
    @on-change="getValue"
    @on-create="handleCreateItem"
  >
    <Option
      v-for="item in placeListShow"
      :key="item.placeId"
      :value="item.placeId"
    >{{ item.placeName }}</Option>
  </Select>
</template>
<script>
import schoolAdmin from '@/request/schoolAdmin/index.js';
export default {
  components: {
  },
  props: {
    // 学校id
    orgId: {
      type: String,
      default: ''
    },
    // 校区id
    branchId: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {
        return {
          placeId: '',
          placeName: ''
        };
      }
    } // v-model的值
    // // 课室id
    // classroomId: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      tableLoading: false,
      placeName: '',
      placeId: '',
      placeList: [],
      placeCreateList: []
    };
  },
  computed: {
    baseInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    placeListShow() {
      return [...this.placeList, ...this.placeCreateList];
    }
  },
  watch: {
    orgId(newVal) {
      this.baseInfo.placeId = '';
      this.baseInfo.placeName = '';
      if (newVal) {
        this.getPlaceListData();
      }
    },
    baseInfo: {
      deep: true,
      handler(newVal) {
        const index = this.placeListShow.findIndex(x => {
          return newVal.placeName && (x.placeName === newVal.placeName);
        });
        index === -1 ? this.placeCreateList.push({
          placeName: newVal.placeName,
          placeId: newVal.placeName
        }) : '';
      }
    }
  },
  created() {
    console.log('创建场地组件000000');
    this.getPlaceListData();
  },
  methods: {
    getValue({ label }) {
      this.baseInfo.placeName = label;
    },
    // 获取场地
    beforeGetPlaceList(query = null) {
      query ? '' : query = null;
      this.loading = true;
      this.getPlaceListData(query);
    },
    handleCreateItem(val) {
      this.baseInfo.placeName = val;
      this.placeCreateList.push({
        placeName: val,
        placeId: val
      });
    },
    // loadAllPlaceList(val) {
    //   console.log(val, '测试展开弹窗----');
    //   if (!val) {
    //     this.getPlaceListData('');
    //   }
    // },
    getPlaceId() {
      console.log(this.baseInfo.placeId, '2');
    },
    getPlaceName() {
      const key = this.placeList.findIndex(item => { return item.placeId == this.baseInfo.placeId; }); let str = '';
      key != -1 ? str = this.placeList[key]['placeName'] : str = '';
      return str;
    },
    // 获取场地列表
    async getPlaceListData(placeName) {
      const params = {
        searchStr: placeName,
        orgId: this.orgId, // 学校id
        branchId: this.branchId, // 校区id
        placeSts: 1, // 场地状态 1：启用 0：禁用
        pageNum: 1,
        pageSize: 10000
      };
      const res = await schoolAdmin.getPlacesQuerylist(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.placeList = res.message.list;
        console.log('重新发起请求场地---');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
